import {
  toWSDateString,
  WSCard,
  WSDataItem,
  WSElement,
  WSList,
  WSSectionToolbar
} from "@wingspanhq/fe-component-library";
import React from "react";

const EMPTY_VALUE = "—";

type Props = {
  payPeriodRange: string;
  paidDate?: Date;
  employerName: string;
  /**
   * Payout destination for this pay. Optional because v3 cannot resolve it yet:
   * it needs PayoutSettings + ExternalBankAccount, gated by a payer→payee
   * bank-data grant (PLA-3198). Until then the card shows the fallbacks below.
   */
  paymentMethodLabel?: string;
  /** Percentage of pay routed to the payout method, e.g. 100. */
  paymentSplit?: number;
  onManagePaymentSettings?: () => void;
};

export const PaystubDetailsCard: React.FC<Props> = ({
  payPeriodRange,
  paidDate,
  employerName,
  paymentMethodLabel = EMPTY_VALUE,
  paymentSplit = 0,
  onManagePaymentSettings
}) => (
  <WSElement>
    <WSSectionToolbar
      button={{
        label: "Manage payment settings",
        onClick: onManagePaymentSettings
      }}
      title="Paystub details"
    />
    <WSCard mt="M">
      <WSList gap="L">
        <WSDataItem label="Pay period" value={payPeriodRange} />
        <WSDataItem
          label="Paid date"
          value={
            paidDate ? toWSDateString(paidDate, "monthDayYear") : EMPTY_VALUE
          }
        />
        <WSDataItem label="Employer name" value={employerName} />
        <WSDataItem label="Payment method" value={paymentMethodLabel} />
        <WSDataItem label="Payment split" value={`${paymentSplit}%`} />
      </WSList>
    </WSCard>
  </WSElement>
);
